import React from "react";
import { Money } from "../../../core/Money";
import { Icon } from "../../../core/Icon";
import moment from "moment";
import { Countdown } from "../../common/event/Countdown";
import { Link } from "react-router-dom";
import { getEventState, EEventTimeState } from "../../common/event/EventHelper";
import NumberFormat from 'react-number-format';
import { phpBool } from "../../../core/Helpers";
export const Intel = (props) => {
    const { eventData, urlEventId, enrollment } = props;
    const eventState = getEventState(eventData);
    var controlHtml = null;
    if (eventState.timeState == EEventTimeState.Closed) {
        if (eventData.winner_id) {
            controlHtml = React.createElement("div", { className: "ed-resolution" },
                "V\u00EDt\u011Bzem aukce se stal \u00FA\u010Dastn\u00EDk s ID ",
                eventData.winner_enrollment_id,
                ", za cenu ",
                React.createElement(Money, { amount: eventData.price }),
                ".");
        }
        else {
            controlHtml = React.createElement("div", { className: "ed-resolution" }, "Aukce nebyla \u00FAsp\u011B\u0161n\u00E1.");
        }
    }
    else {
        if (enrollment.id) {
            if (eventState.timeState == EEventTimeState.ToBe)
                controlHtml = React.createElement("button", { disabled: true, className: "primary-button" }, "P\u0159ihl\u00E1\u0161en\u00ED do aukce");
            if (eventState.timeState == EEventTimeState.Open) {
                if (enrollment.confirmed > 0) {
                    if (eventData.price) {
                        if (phpBool(enrollment.preemptive) && enrollment.id !== eventData.winner_enrollment_id) {
                            controlHtml = React.createElement("form", { onSubmit: (e) => props.tryBid(e, true) },
                                React.createElement("button", { type: "submit", className: "primary-button" }, "Dorovnat (vyu\u017E\u00EDt p\u0159edkupn\u00ED pr\u00E1vo)"));
                        }
                        else {
                            controlHtml = React.createElement("form", { onSubmit: (e) => props.tryBid(e) },
                                React.createElement(NumberFormat, { onValueChange: (val) => props.setBidValue(val.value), thousandSeparator: " ", value: props.bidValue, displayType: 'input', suffix: " K\u010D" }),
                                React.createElement("button", { type: "submit", className: "primary-button fixed" }, "P\u0159ihodit"));
                        }
                    }
                    else {
                        controlHtml = React.createElement("form", { onSubmit: (e) => props.tryBid(e) },
                            React.createElement("button", { type: "submit", className: "primary-button" }, "P\u0159ihl\u00E1sit se k nejni\u017E\u0161\u00EDmu pod\u00E1n\u00ED"));
                    }
                }
                else {
                    controlHtml = React.createElement("button", { disabled: true, className: "primary-button" }, "Je t\u0159eba splnit podm\u00EDnky pro \u00FA\u010Dast");
                }
            }
        }
        else {
            if (eventState.timeState == EEventTimeState.ToBe) {
                controlHtml = React.createElement(Link, { to: "/cs/proces/zapsat-k-aukci/" + urlEventId, className: "primary-button" }, "P\u0159ihl\u00E1\u0161en\u00ED do aukce");
            }
        }
    }
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ed-winner" },
            eventData.winner_id &&
                React.createElement("div", { className: "ed-winid" },
                    React.createElement("span", { className: "ed-winid-figure" },
                        React.createElement(Icon, { c: ['user', 12, 12] }),
                        eventData.winner_enrollment_id),
                    React.createElement("span", { className: "ed-winid-label" }, "\u00DA\u010Dastn\u00EDk s nejvy\u0161\u0161\u00EDm pod\u00E1n\u00EDm")),
            React.createElement("div", { className: "ed-price" }, eventData.price ?
                React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "ed-price-figure" },
                        React.createElement(Money, { amount: eventData.price })),
                    React.createElement("span", { className: "ed-price-label" }, "Nejvy\u0161\u0161\u00ED pod\u00E1n\u00ED"))
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "ed-price-figure" },
                            React.createElement(Money, { amount: eventData.lowest_bid })),
                        React.createElement("span", { className: "ed-price-label" }, "Nejni\u017E\u0161\u00ED pod\u00E1n\u00ED")))),
        React.createElement("div", { className: "ed-lines" },
            React.createElement("div", { className: "line" },
                React.createElement("span", { className: "lbl" }, "Za\u010D\u00E1tek aukce"),
                React.createElement("span", { className: "vle" }, eventData.start ? moment.unix(eventData.start).format('D. M. YYYY, HH:mm') : 'Nestanoveno')),
            React.createElement("div", { className: "line" },
                React.createElement("span", { className: "lbl" }, "Konec aukce"),
                React.createElement("span", { className: "vle" }, eventData.end ? moment.unix(eventData.end).format('D. M. YYYY, HH:mm') : 'Nestanoveno')),
            React.createElement("div", { className: "line" },
                React.createElement("span", { className: "lbl" }, "Min./max. p\u0159\u00EDhoz"),
                React.createElement("span", { className: "vle" },
                    React.createElement(Money, { amount: eventData.bid_increase }),
                    " / ",
                    eventData.bid_increase_max ? React.createElement(Money, { amount: eventData.bid_increase_max }) : 'Neomezeno')),
            React.createElement("div", { className: "line" },
                React.createElement("span", { className: "lbl" }, "Nejni\u017E\u0161\u00ED pod\u00E1n\u00ED"),
                React.createElement("span", { className: "vle" },
                    React.createElement(Money, { amount: eventData.lowest_bid }))),
            React.createElement("div", { className: "line" },
                React.createElement("span", { className: "lbl" }, "Auk\u010Dn\u00ED jistota"),
                React.createElement("span", { className: "vle" }, eventData.assurance ? React.createElement(Money, { amount: eventData.assurance }) : 'Nestanoveno')),
            React.createElement("div", { className: "line" },
                React.createElement("span", { className: "lbl" }, "\u010Cas prodlou\u017Een\u00ED"),
                React.createElement("span", { className: "vle" }, eventData.prolongation_time ? (Math.round(eventData.prolongation_time / 60) + ' minut(y)') : 'Bez prodloužení')),
            eventState.timeState == EEventTimeState.ToBe &&
                React.createElement("div", { className: "line" },
                    React.createElement("span", { className: "lbl" }, "\u010Cas do zah\u00E1jen\u00ED"),
                    React.createElement("span", { className: "vle" },
                        React.createElement(Countdown, { reloadOnZero: true, start: eventData.start }))),
            eventState.timeState == EEventTimeState.Open &&
                React.createElement("div", { className: "line" },
                    React.createElement("span", { className: "lbl" }, "\u010Cas do konce"),
                    React.createElement("span", { className: "vle" },
                        React.createElement(Countdown, { reloadOnZero: true, start: eventData.end })))),
        React.createElement("div", { className: "ed-actions" }, controlHtml));
};
/*

  {
                eventState.timeState == EEventTimeState.ToBe &&
                <>
                    {
                        enrollment && enrollment.id ? <button disabled={true} className="primary-button">Přihlášení do aukce</button>
                            :
                            <Link to={"/cs/proces/zapsat-k-aukci/" + urlEventId} className="primary-button">Přihlášení do aukce</Link>
                    }
                </>
            }
            {
                eventState.timeState == EEventTimeState.Open && enrollment && enrollment.id &&
                <>
                    {eventData.price ?
                        <form onSubmit={(e) => props.tryBid(e)}>
                            <NumberFormat onValueChange={(val) => props.setBidValue(val.value)} thousandSeparator=" " value={props.bidValue} displayType='input' suffix=" Kč" />
                            <button type="submit" className="primary-button">Přihodit</button>
                        </form>
                        :
                        <form onSubmit={(e) => props.tryBid(e)}>
                            <button type="submit" className="primary-button">Přihlásit se k nejnižšímu podání</button>
                        </form>
                    }
                </>
            }

            */ 
